import { render, staticRenderFns } from "./RoleDefBadge.vue?vue&type=template&id=1c529187&scoped=true"
import script from "./RoleDefBadge.vue?vue&type=script&lang=ts"
export * from "./RoleDefBadge.vue?vue&type=script&lang=ts"
import style0 from "./RoleDefBadge.vue?vue&type=style&index=0&id=1c529187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c529187",
  null
  
)

export default component.exports